<template>
  <div :class="$style['subnav-panel']" ref="rootDom">
    <div :class="$style['panel-inner']">
      <div :class="$style['user-info-group']" class="flex items-center">
        <div :class="$style['user-avatar']">
          <img v-if="userInfo && userInfo.type != 3" :src="userInfo.avatarUrl ? userInfo.avatarUrl : 'https://static.spex.ltd/SuperEx/static/default_img.png'" alt=""/>
          <img v-if="userInfo && userInfo.type == 3" :src="$parent.walletConfig.imageUrl" alt/>
        </div>&nbsp;&nbsp;
        <div :class="$style['user-info']">
          <div v-if="userInfo && userInfo.type != 3" :class="$style['user-name']">
            {{ userInfo && userInfo.email ? emailShow(userInfo.email) : telephoneShow(userInfo.phone) }}
          </div>
          <div v-else :class="$style['user-name']" style="margin-bottom: 0">{{ ellipseAddress(walletAddress) }}</div>
          <div v-if="userInfo && userInfo.type != 3" :class="$style['user-uid']" class="flex items-center nowrap"
               @click="copyUID(userInfo.id)">
            <span :class="$style['text']">UID {{ userInfo.id }}</span>
            <i :class="$style['ic']" class="ueicon-copy"></i>
          </div>
        </div>
      </div>
      <div :class="$style['user-tag-group']" class="flex">
        <div v-if="agentStatus == 1" :class="$style['user-tag']" class="flex items-center justify-center"
             @click="toAgent">{{ $t('410001') }}
        </div>
        <div v-else :class="$style['user-tag']" class="flex items-center justify-center" @click="goLink('/userCenter/preferences')">
          {{ $t('user_panel.general_user') }}
        </div>
        <div :class="$style['user-level']" @click="toLever">
          <div :class="$style['inner']" class="flex items-center">
            <img :class="$style['ic']" src="https://static.spex.ltd/static/images/index/level-icon.png"
                 alt="logo"/>
            <span :class="$style['text']">VIP {{ userInfo.level }}</span>
          </div>
        </div>
      </div>
      <div :class="$style['nav-list']">
        <a
            v-for="(item, index) in userPanelNavList"
            :key="index"
            v-show="isItemVisible(item)"
            :class="$style['nav-item']"
            @click="toLink(item)"
        >
          <div :class="$style['item-inner']" class="flex">
            <div :class="$style['item-icon']">
              <i v-if="!item.iconType" :class="[$style['ic'], item.icon]"></i>
              <Exicon v-else :size="18" :name="item.icon"/>
            </div>
            <div :class="$style['item-content']">
              <div :class="$style['item-title']">{{ item.title }}</div>
            </div>
          </div>
        </a>
        <div :class="$style['nav-item']" @click="logout">
          <div :class="$style['item-inner']" class="flex">
            <div :class="$style['item-icon']">
              <i :class="[$style['ic']]" class="ueicon-tui-chu"></i>
            </div>
            <div :class="$style['item-content']">
              <div :class="$style['item-title']">{{ $t("400021") }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import copy from "copy-to-clipboard";
import {mapGetters} from "vuex";
import {getToken} from '@/utils/common'
import {useLighterBorder} from '../../plugins/use-lighter-border'
import {emailShow, telephoneShow, ellipseAddress} from "../../plugins/methods";
import {getC2cUserInfo} from '@/apis/otc.js'
import {checkIsAgentState} from '@/apis/agent.js'
import urls from "@/utils/baseUrl";
import {buildMainSiteUrl} from '@/utils/navigate-nav-item'

export default {
  name: "UserPanel",
  data() {
    return {
      cleanupLighterBorder: null,
      agentStatus: 0,
      userPanelNavList: [
        {icon: 'ueicon-zong-lan', title: this.$t('400015'), path: '/userCenter/overview', type: 1},
        {
          icon: 'icon-a-shanghuzhongxinbaixin',
          title: this.$t('user_panel.91002529'),
          path: '/thirdPartyPayment/companyOverview',
          type: 1,
          iconType: true,
          // 动态控制显示：商户用户展示
          isVisible: () => (this.userInfo && this.userInfo.type == 4)
        },
        {
          icon: 'ueicon-an-quan-zhong-xin',
          title: this.$t('user_panel.security_center'),
          path: '/userCenter/account',
          type: 1
        },
        {
          icon: 'ueicon-shen-fen-ren-zheng',
          title: this.$t('400016'),
          path: '/userCenter/complete',
          type: 6,
        },
        {
          icon: 'ueicon-yao-qing-jiang-li',
          title: this.$t('user_panel.invite_reward'),
          path: '/userCenter/commission',
          type: 1
        },
        {
          icon: 'ueicon-ka-quan-zhong-xin',
          title: this.$t('400020'),
          path: '/userCenter/couponCenter',
          type: 1
        },
        {
          icon: 'ueicon-wo-de-huo-dong',
          title: this.$t('user_panel.my_activity'),
          path: '/events',
          type: 1
        },
        {icon: 'ueicon-di-zhi-bu', title: this.$t('user_panel.100533'), path: '/userCenter/addressBook', type: 1},
        {icon: 'ueicon-api-guan-li', title: this.$t('9100162'), path: '/userCenter/api', type: 1},
        {icon: 'ueicon-she-zhi', title: this.$t('user_panel.100729'), path: '/userCenter/preferences', type: 1}
      ],
      linkUrl: urls.linkUrl,
      oldArchitectureUrl: urls.oldArchitectureUrl || urls.linkUrl
    };
  },
  computed: {
    ...mapGetters(["token", "userInfo", "walletAddress", "language"]),
  },
  mounted() {
    this.cleanupLighterBorder = useLighterBorder(
        this,
        this.$refs.rootDom
    );
    if (this.token) {
      this.getCheckIsAgentState()
    }
  },
  methods: {
    // 判断导航项是否显示
    isItemVisible(item) {
      if (typeof item.isVisible === 'function') {
        try {
          return !!item.isVisible.call(this);
        } catch (e) {
          return true;
        }
      }
      if (typeof item.isVisible === 'boolean') return item.isVisible;
      return true;
    },
    toLink(data) {
      if (data.type === 6) {
        if (this.token) {
          this.getC2cUserInfo()
        }
        return
      } else {
        if (data.path.indexOf('/thirdPartyPayment/') === 0) {
          window.open(this.oldArchitectureUrl + data.path)
          return
        }
        window.open(buildMainSiteUrl(this.linkUrl, data.path, this.language))
      }
    },
    goLink(link) {
      window.open(buildMainSiteUrl(this.linkUrl, link, this.language))
    },
    // 身份认证
    getC2cUserInfo() {
      getC2cUserInfo().then((res) => {
        this.c2cUserInfo = res.data
        let Url = this.c2cUserInfo.isAuth ? '/userCenter/complete' : '/userCenter/identity'
        window.location.href = buildMainSiteUrl(this.linkUrl, Url, this.language)
      })
    },
    // 手机号处理
    telephoneShow(phone) {
      return phone ? telephoneShow(phone) : ''
    },
    // 邮箱地址处理
    emailShow(email) {
      return email ? emailShow(email) : ''
    },
    // 钱包地址处理
    ellipseAddress(str) {
      return ellipseAddress(str)
    },
    copyUID(uid) {
      const copyResult = copy(uid);
      if (copyResult) {
        this.$notify.success(this.$t("300195"));
      } else {
        this.$notify.error(this.$t("300196"));
      }
    },
    logout() {
      this.$store.dispatch('LogOut', getToken() ? getToken() : '')
    },
    toAgent() {
      if (this.agentStatus === 1) {
        window.location.href = buildMainSiteUrl(this.linkUrl, '/agentSystem/dataBoard', this.language)
      } else {
        window.location.href = buildMainSiteUrl(this.linkUrl, '/agentSystem/agentHome', this.language)
      }
    },
    toLever() {
      window.location.href = buildMainSiteUrl(this.linkUrl, '/userCenter/fee/trading', this.language)
    },
    getCheckIsAgentState() {
      checkIsAgentState()
          .then((res) => {
            this.agentStatus = res.data.status
          })
          .catch((err) => {
            console.log(err.code, '返回了500哦')
          })
    }
  },
  beforeDestroy() {
    if (this.cleanupLighterBorder) {
      this.cleanupLighterBorder();
    }
  },
};
</script>
<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/_mixins";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

:global(html[data-theme="sunlight"]) {
  .subnav-panel {
    border-color: rgba(0, 0, 0, 0.1);
    background-color: #fff;
    box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);

    .user-info-group {
      .user-name {
        color: #000;
      }
    }

    .user-tag-group {
      .user-tag {
        color: rgba(#000, 1);
        background: rgba(#000, 0.1);
      }

      .user-level {
        .inner {
          background-color: #fff;
        }
      }
    }

    .nav-item {
      &:hover {
        background: #f6f6f6;

        .item-title,
        .item-icon {
          color: color(var(--theme-color));
        }
      }

      .item-title,
      .item-icon {
        color: color(var(--font-color), 1);
      }
    }
  }
}

.subnav-panel {
  --border-width: 1px;
  min-width: 195px;
  padding: 14px;

  text-align: left;

  border: var(--border-width) solid rgba(#fff, 0.1);
  border-radius: 8px;
  background: #202020;
  box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.3);

  .user-info-group {
    margin-bottom: 10px;

    .user-avatar {
      @include circle(48px);

      img {
        @include circle(48px);
      }
    }

    .user-name {
      font-family: "Plus Jakarta Sans";
      font-size: 13px;
      font-weight: 600;
      line-height: 106%; /* 13.78px */

      margin-bottom: 10px;

      transition: var(--transition-theme-color);

      color: #fff;
    }

    .user-uid {
      font-family: "Plus Jakarta Sans";
      font-size: 12px;
      font-weight: 500;
      line-height: 106%; /* 12.72px */

      transition: var(--transition-theme-color);

      color: color(var(--font-color), 0.6);

      gap: 10px;

      &:hover {
        color: color(var(--font-color), 1);
      }

      .ic {
        font-size: 16px;
      }
    }
  }

  .user-tag-group {
    font-size: 10px;
    font-weight: 400;
    line-height: 106%; /* 10.6px */

    margin-bottom: 20px;

    gap: 10px;

    .user-tag {
      width: fit-content;
      padding: 4px 8px;

      transition: var(--transition-theme-color);

      color: color(var(--font-color));
      border-radius: 4px;
      background: rgba(#fff, 0.1);
    }

    .user-level {
      padding: 1px;

      color: color(var(--theme-color));
      border-radius: 4px;
      background-image: linear-gradient(92.27deg, #ffefcd -21.16%, #ffca63 81.8%);

      .inner {
        padding: 4px 8px;

        border-radius: inherit;
        background: #363636;
      }

      .ic {
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }
    }
  }

  .nav-list {
    display: grid;

    gap: 10px;
  }

  .nav-item {
    padding: 7px 12px;

    transition: var(--transition-theme-color);

    border-radius: 6px;

    &:hover {
      color: color(var(--theme-color));
      background: #282828;

      .item-icon,
      .item-title,
      .item-subtitle {
        color: inherit;
      }
    }

    .item-inner {
      white-space: nowrap;

      align-items: center;
      gap: 8px;
    }

    .item-icon {
      font-size: 18px;
      line-height: 1;

      transition: var(--transition-theme-color);
      transform: translateY(0.06em);

      color: color(var(--font-color));
    }

    .item-title {
      font-size: 14px;
      font-weight: 500;
      line-height: 160%; /* 22.4px */

      transition: var(--transition-theme-color);

      color: color(var(--font-color));
    }

    .item-subtitle {
      font-size: 12px;
      font-weight: 400;
      line-height: 160%; /* 19.2px */

      transition: var(--transition-theme-color);

      color: color(var(--font-color), 0.6);
    }
  }
}
</style>
